import React, { useState } from 'react';
import './Careers.css';

const Careers = () => {
    // State for department filtering
    const [activeFilter, setActiveFilter] = useState('all');

    // Hero stats data
    const heroStats = [
        { number: '50+', label: 'Team Members' },
        { number: '1000+', label: 'Happy Clients' },
        { number: '25+', label: 'Cities' },
        { number: '15+', label: 'Open Positions' }
    ];

    // Benefits data
    const benefits = [
        {
            icon: 'fa-rocket',
            title: 'Rapid Growth',
            description: 'Fast-growing company with opportunities for quick career advancement and skill development.'
        },
        {
            icon: 'fa-graduation-cap',
            title: 'Learning & Development',
            description: 'Regular training, workshops, and certifications to keep you ahead in the real estate tech industry.'
        },
        {
            icon: 'fa-users',
            title: 'Great Culture',
            description: 'Collaborative environment, team events, and a supportive work culture that values every member.'
        },
        {
            icon: 'fa-hand-holding-usd',
            title: 'Competitive Benefits',
            description: 'Attractive compensation, health insurance, performance bonuses, and flexible work options.'
        },
        {
            icon: 'fa-home',
            title: 'Real Estate Perks',
            description: 'Special employee discounts on properties, exclusive market insights, and networking opportunities.'
        },
        {
            icon: 'fa-balance-scale',
            title: 'Work-Life Balance',
            description: 'Flexible hours, remote work options, and generous leave policies for a balanced lifestyle.'
        }
    ];

    // Job positions data
    const positions = [
        {
            id: 1,
            title: "Real Estate Sales Manager",
            department: "sales",
            type: "Full-time",
            location: "Delhi, Mumbai",
            experience: "5+ years experience",
            posted: "2 days ago",
            openings: 5,
            description: "Lead our sales team and drive property sales across major metropolitan areas."
        },
        {
            id: 2,
            title: "Frontend Developer",
            department: "technology",
            type: "Full-time",
            location: "Remote / Bangalore",
            experience: "3+ years experience",
            posted: "5 days ago",
            openings: 3,
            description: "Build beautiful, responsive interfaces for our real estate platform using modern web technologies."
        },
        {
            id: 3,
            title: "Client Relationship Manager",
            department: "customer-service",
            type: "Full-time",
            location: "Hyderabad, Chennai",
            experience: "4+ years experience",
            posted: "1 week ago",
            openings: 2,
            description: "Manage and nurture relationships with our premium clients and property investors."
        },
        {
            id: 4,
            title: "Property Photographer",
            department: "marketing",
            type: "Contract",
            location: "Multiple Locations",
            experience: "2+ years experience",
            posted: "3 days ago",
            openings: 4,
            description: "Capture stunning visuals of properties for our listings and marketing materials."
        },
        {
            id: 5,
            title: "Data Analyst",
            department: "technology",
            type: "Full-time",
            location: "Gurgaon",
            experience: "3+ years experience",
            posted: "1 week ago",
            openings: 2,
            description: "Analyze real estate market data to provide insights for business decisions."
        },
        {
            id: 6,
            title: "Customer Support Executive",
            department: "customer-service",
            type: "Full-time",
            location: "Pune",
            experience: "1+ years experience",
            posted: "1 day ago",
            openings: 6,
            description: "Assist customers with property inquiries and provide excellent service."
        }
    ];

    // Filter buttons data
    const filters = [
        { key: 'all', label: 'All Departments' },
        { key: 'sales', label: 'Sales & Marketing' },
        { key: 'technology', label: 'Technology' },
        { key: 'customer-service', label: 'Customer Service' },
        { key: 'operations', label: 'Operations' }
    ];

    // Filter positions based on active filter
    const filteredPositions = activeFilter === 'all'
        ? positions
        : positions.filter(pos => pos.department === activeFilter);

    // Event handlers
    const handleApply = (positionTitle) => {
        alert(`Applying for: ${positionTitle}\n\nThis would open an application form.`);
        // In real implementation, open modal or navigate to application form
    };

    const handleBrowsePositions = () => {
        // Scroll to positions section
        const positionsSection = document.querySelector('.cr-positions-section');
        if (positionsSection) {
            positionsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleGeneralApplication = () => {
        alert('Opening general application form...');
        // In real implementation, open modal or navigate to form
    };

    // Format department name for display
    const formatDepartment = (dept) => {
        return dept.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
    };

    return (
        <div className="careers-page">

            {/* ===== HERO SECTION ===== */}
            <section className="cr-hero-section">
                <div className="cr-hero-content">
                    <div className="cr-hero-badge">
                        <i className="fas fa-star"></i> We're Hiring
                    </div>
                    <h1 className="cr-hero-title">Build Your Career in Real Estate</h1>
                    <p className="cr-hero-subtitle">
                        Join BGRealEstate360 and be part of revolutionizing the real estate industry
                        with innovative technology and exceptional service.
                    </p>

                    <div className="cr-hero-stats">
                        {heroStats.map((stat, index) => (
                            <div key={index} className="cr-hero-stat">
                                <div className="cr-stat-number">{stat.number}</div>
                                <div className="cr-stat-label">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ===== WHY JOIN US SECTION ===== */}
            <section className="cr-why-join-section">
                <div className="cr-section-header">
                    <h2 className="cr-section-title">Why Join BGRealEstate360?</h2>
                    <p className="cr-section-subtitle">
                        We're not just a real estate company - we're a technology-driven platform
                        changing how people buy, sell, and experience properties.
                    </p>
                </div>

                <div className="cr-benefits-grid">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="cr-benefit-card">
                            <div className="cr-benefit-icon">
                                <i className={`fas ${benefit.icon}`}></i>
                            </div>
                            <h3 className="cr-benefit-title">{benefit.title}</h3>
                            <p className="cr-benefit-desc">{benefit.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ===== OPEN POSITIONS SECTION ===== */}
            <section className="cr-positions-section">
                <div className="cr-positions-header">
                    <h2 className="cr-positions-title">Current Openings</h2>
                    <div className="cr-department-filter">
                        {filters.map(filter => (
                            <button
                                key={filter.key}
                                className={`cr-filter-btn ${activeFilter === filter.key ? 'active' : ''}`}
                                onClick={() => setActiveFilter(filter.key)}
                            >
                                {filter.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="cr-positions-grid">
                    {filteredPositions.map(position => (
                        <div key={position.id} className="cr-position-card">
                            <div className="cr-position-info">
                                <div className="cr-position-meta">
                                    <span className="cr-position-tag">{formatDepartment(position.department)}</span>
                                    <span className="cr-position-tag">{position.type}</span>
                                    <span className="cr-position-tag">{position.location}</span>
                                </div>
                                <h3 className="cr-position-title">{position.title}</h3>
                                <p>{position.description}</p>
                                <div className="cr-position-details">
                                    <div className="cr-position-detail">
                                        <i className="fas fa-briefcase"></i>
                                        <span>{position.experience}</span>
                                    </div>
                                    <div className="cr-position-detail">
                                        <i className="fas fa-calendar-alt"></i>
                                        <span>Posted {position.posted}</span>
                                    </div>
                                    <div className="cr-position-detail">
                                        <i className="fas fa-users"></i>
                                        <span>{position.openings} opening{position.openings > 1 ? 's' : ''}</span>
                                    </div>
                                </div>
                            </div>
                            <button
                                className="cr-position-apply-btn"
                                onClick={() => handleApply(position.title)}
                            >
                                Apply Now
                                <i className="fas fa-arrow-right"></i>
                            </button>
                        </div>
                    ))}

                    {filteredPositions.length === 0 && (
                        <div className="cr-no-positions">
                            <i className="fas fa-search"></i>
                            <h3>No positions found in this category</h3>
                            <p>Try selecting a different department or check back later for new openings.</p>
                        </div>
                    )}
                </div>
            </section>

            {/* ===== CTA SECTION ===== */}
            <section className="cr-cta-section">
                <div className="cr-cta-content">
                    <h2 className="cr-cta-title">Ready to Join Our Team?</h2>
                    <p className="cr-cta-subtitle">
                        Don't see a position that matches your skills? We're always looking for talented
                        individuals. Send us your resume and tell us how you can contribute.
                    </p>
                    <div className="cr-cta-buttons">
                        <button className="cr-cta-primary-btn" onClick={handleBrowsePositions}>
                            Browse All Positions
                            <i className="fas fa-search"></i>
                        </button>
                        <button className="cr-cta-secondary-btn" onClick={handleGeneralApplication}>
                            Submit General Application
                            <i className="fas fa-paper-plane"></i>
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Careers;